import React from 'react'
import classnames from 'classnames';
import { PropTypes } from 'prop-types';

function TextFieldGroup({
 name,
 id,
 placeholder,
 value,
 label,
 error,
 info,
 type,
 onChange,
 disabled
}) {
 return (
  <div className="form-group">
   <input
    type={type}
    className={classnames('form-control form-control-lg', {
     'is-invalid': error
    })}
    placeholder={placeholder}
    name={name}
    id={id}
    value={value}
    onChange={onChange}
    disabled={disabled}
    label={label}
   />
   {info && <small className="form-text text-muted">{info}</small>}
   {error && (<div className="invalid-feedback">{error}</div>)}
  </div>
 )
}

TextFieldGroup.propTypes = {
 name: PropTypes.string.isRequired,
 id: PropTypes.string,
 placeholder: PropTypes.string,
 value: PropTypes.string.isRequired,
 info: PropTypes.string,
 error: PropTypes.string,
 type: PropTypes.string.isRequired,
 onChange: PropTypes.func.isRequired,
 disabled: PropTypes.string,
 label: PropTypes.string
}

TextFieldGroup.defaultProps = {
 type: "text"
}

export default TextFieldGroup;